import BigNumber from 'bignumber.js';

export function formatUsdcBalance(amount: BigNumber) {
  return amount.toFormat(2);
}
